'use client'

import type { PropsWithChildren } from 'react'

import { YoutubeVideo } from '@marketing-sites/blog-components/components/ComposeComponentYoutubeVideo'
import { ContentfulProvider } from '@marketing-sites/blog-components/utils/contentful-context'
import { BlockQuote } from '@marketing-sites/blog-components/components/ComposeComponentBlockQuote'
import { ContentfulImage } from '@marketing-sites/blog-components/components/ComposeComponentImage'
import { ContentfulRichText } from '@marketing-sites/blog-components/components/ContentfulRichText'
import { ContentfulImageWithPlaceholder } from '@marketing-sites/blog-components/components/ContentfulImageWithPlaceholder'
import { DownloadableAsset } from '@marketing-sites/blog-components/components/ComposeComponentDownloadableAsset'
import { HorizontalImageCTA } from '@marketing-sites/blog-components/components/ComposeComponentHorizontalImageCTA'
import { ImageAndAdjacentTextList } from '@marketing-sites/blog-components/components/ComposeComponentImageAndAdjacentTextList'
import { RichTextColouredBackground } from '@marketing-sites/blog-components/components/ComposeComponentRichTextColouredBackground'
import { ComposeComponentRichTextCTA } from '@marketing-sites/blog-components/components/ComposeComponentRichTextCTA'

const blockComponents = {
  ContentfulRichText,
  ContentfulImageWithPlaceholder,
  BlockQuote,
  DownloadableAsset,
  HorizontalImageCTA,
  ContentfulImage,
  ImageAndAdjacentTextList,
  RichTextColouredBackground,
  ComposeComponentRichTextCTA,
  YoutubeVideo,
}

export default function Provider({ children }: PropsWithChildren) {
  return (
    <ContentfulProvider blockComponents={blockComponents} inlineComponents={{}}>
      {children}
    </ContentfulProvider>
  )
}
